import Emitter from 'tiny-emitter';
export default class Swipe extends Emitter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    this.drag = {
      x: 0,
      dx: 0,
      started: false
    };
    this.minThreshold = options.minThreshold || 8;
    this.maxThreshold = options.maxThreshold || 50;
    this.onDragStart = this.onDragStart.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.addEvents();
  }

  addEvents() {
    window.addEventListener('touchstart', this.onDragStart);
    window.addEventListener('touchmove', this.onDrag, {
      passive: false
    });
    window.addEventListener('touchend', this.onDragEnd);
  }

  removeEvents() {
    window.removeEventListener('touchstart', this.onDragStart);
    window.removeEventListener('touchmove', this.onDrag);
    window.removeEventListener('touchend', this.onDragEnd);
  }

  onDragStart(event) {
    this.drag.x = event.changedTouches ? event.changedTouches[0].pageX : event.pageX;
    this.drag.dx = 0;
    this.drag.started = true;
    this.emit('dragstart', {
      x: -this.drag.x
    });
  }

  onDrag(event) {
    if (!this.drag.started) return;
    this.drag.dx = (event.changedTouches ? event.changedTouches[0].pageX : event.pageX) - this.drag.x;
    if (Math.abs(this.drag.dx) < this.minThreshold) return;
    let dx = Math.min(this.maxThreshold, Math.abs(this.drag.dx));
    let direction = Math.sign(-this.drag.dx);
    event.preventDefault();
    this.emit('drag', {
      x: direction * dx,
      direction
    });

    if (Math.abs(this.drag.dx) > this.maxThreshold) {
      this.onDragEnd(event);
    }
  }

  onDragEnd(event) {
    if (!this.drag.started) return;
    this.drag.started = false;
    this.emit('dragend', {
      x: this.drag.complete ? -this.drag.dx : 0
    });
  }

  destroy() {
    this.removeEvents();
    this.off();
    clearTimeout(this.dragTimer);
  }

}